// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sent[data-v-524d2056]{transform:rotate(-45deg)}", ""]);
// Exports
module.exports = exports;
